import cookie from 'js-cookie';
import { get } from 'lodash';
import VueI18n from 'vue-i18n';
import messages from '../../i18n/i18n';
import { translation4Rebranding } from '@zoom/billing-rebranding';

const locale = cookie.get('_zm_lang') || 'en-US';

let _i18n = null;

export function translation(i18nKey, params = []) {
  if (!_i18n) {
    _i18n = new VueI18n({
      locale,
      messages,
    });
  }
  return _i18n.t(i18nKey, params);
}

function findPath(obj, value, currentPath = []) {
  for (let key in obj) {
    if (obj[key] === value) {
      return [...currentPath, key];
    } else if (typeof obj[key] === 'object') {
      const result = findPath(obj[key], value, [...currentPath, key]);
      if (result) {
        return result;
      }
    }
  }
  return null;
}

export function translateToEn(key, args = []) {
  let result = get(messages, `en-US.${key}`, key)
  if (typeof result !== 'string') {
    console.error('Invalid key, requires String type')
    return ''
  }
  args.forEach((arg, idx) => {
    result = result.replace(new RegExp(`\\{${idx}\\}`, 'g'), arg)
  })
  return translation4Rebranding(result)
}

export function translateToEnByMessage(message) {
  if (!message) {
    return null;
  }
  const mPath = findPath(messages[locale], message);
  if (!mPath) {
    return null;
  }
  let result = translateToEn(mPath.join('.'));

  return translation4Rebranding(result);
}

const rebrandingVar1 = window?.dataModel?.zoomWorkplaceRebranding === 'Workplace'

const rebrandingVar2 = window.newBillingConfig?.enableZoomWorkPlaceRebranding

const isRebranding = window?.newBillingConfig?.isZoomWorkplaceRebranding || rebrandingVar1 || rebrandingVar2

export const t = translation4Rebranding(translation, isRebranding);
